module.exports = __webpack_public_path__ + "static/media/success.a1f5a8a1.svg";